module.exports = __webpack_public_path__ + "static/img/player.6be80cce.png";